module.exports = __webpack_public_path__ + "static/media/google-play-badge.db36d776.png";